import React from 'react'
import { useSelector } from 'react-redux';


function AuthorizedPerson() {
    const applicationData = useSelector((state)=> state.appViewDetailsSlice);

  return (
    <div>
            <div class="intro-y box mt-lg-5">
        <div class="d-flex align-items-center p-5 border-bottom border-gray-200 dark-border-dark-5">
            <h2 class="fw-medium fs-base me-auto">
                Authorized Person Information
            </h2>
        </div>

        {applicationData.authPerson.length > 0 ? applicationData.authPerson.map((data)=>{return(<div className='border-bottom border-gray-200 dark-border-dark-5'>
            <div class="d-flex flex-column flex-lg-row p-5 pb-10  mx-n5 row">
             <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                 <div class="d-flex flex-column  mt-3">
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> First Name : <div class="text-gray-600 px-2">{data?.firstName} </div></div>
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2"> Suffix : <div class="text-gray-600 px-2">{data?.suffix}</div></div>
                </div>
            </div>
                <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                <div class="d-flex flex-column  mt-3">
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Last Name : <div class="text-gray-600 px-2"> {data?.lastName}</div> </div>
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Same Address as patient? <div class="text-gray-600 px-2">{data?.isAddressSameAsPatient}</div></div>

                </div>
            </div>
            <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
                <div class="d-flex flex-column  mt-3">
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Relationship To Patient : <div class="text-gray-600 px-2"> {data?.relationshipToPatient} </div></div>
                    <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Same Phone number as Patient? <div class="text-gray-600 px-2">{data?.isContactSameAsPatient}</div> </div>                   
               </div>
           </div>
        </div>
        <div class="d-flex flex-column flex-lg-row p-5 pb-10 mx-n5 row">
        <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
            <div class="d-flex flex-column  mt-3">
            <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2" style={{textWrap: "balance"}}> Would the patient like program communications sent to this authorized person via email?</div>
            <div class="text-gray-600 px-2">{data?.isToReciveEmail}</div>
            </div>
       </div>
           <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
           <div class="d-flex flex-column  mt-3">
           {data?.isToReciveEmail =='Yes' && <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Email  : <div class="text-gray-600 px-2">{data?.email}</div></div> }
            </div>
       </div>
   </div>
        {
    data.isAddressSameAsPatient == 'No' && <>
    <div class="d-flex flex-column flex-lg-row p-5 pb-10 mx-n5 row">
        <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
            <div class="d-flex flex-column  mt-3">
               <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Address Line 1 : <div class="text-gray-600 px-2">{data.addressLine1} </div></div>
               <div class="truncate white-space-sm-normal d-flex align-items-center mt-3 px-2"> State : <div class="text-gray-600 px-2">{data.State}</div></div>
           </div>
       </div>
           <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
           <div class="d-flex flex-column  mt-3">
               <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Address Line 2 : <div class="text-gray-600 px-2">{data.addressLine2}</div> </div>
               <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Zipcode : <div class="text-gray-600 px-2">{data.zipcode}</div></div>

           </div>
       </div>
       <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 pt-5 pt-lg-0">
           <div class="d-flex flex-column  mt-3">
               <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> City : <div class="text-gray-600 px-2">{data.city} </div></div>
              
          </div>
      </div>
   </div>
    </>
   }
     {
    data.isContactSameAsPatient == 'No' && <>
    <div class="d-flex flex-column flex-lg-row p-5 pb-10 mx-n5 row">
        <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 px-5 pt-5 pt-lg-0">
            <div class="d-flex flex-column  mt-3">
               <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2"> Phone Number : <div class="text-gray-600 px-2">{data.phoneNumber} </div></div>
          </div>
       </div>
           <div class="mt-6 mt-lg-0 flex-1 dark-text-gray-300 px-5 pt-5 pt-lg-0">
           <div class="d-flex flex-column  mt-3">
               <div class="truncate white-space-sm-normal d-flex align-items-center mt-3  px-2">Phone Type : <div class="text-gray-600 px-2">{data.phoneType}</div> </div>
           </div>
       </div>
   </div>
    </>
   }
        </div>)}) :  <h2 class="fw-medium fs-base me-auto">No Authorized Person Details Available</h2>}
    </div>
    </div>
  )
}

export default AuthorizedPerson